<template>
  <b-card class="!border-[1px] !border-[#E2E2E2] !border-solid !shadow-none !-mt-[10px]">
    <h3 class="font-semibold text-[#333] text-[20px] pb-[16px] mb-0">
      Campaign List
    </h3>
    <TabComponent
      default-tab-had-count
      :tabs="tabList"
      :count="campaignCounts"
      :variant="{
        active: 'primary',
        inactive: 'light',
      }"
      @tab-change="handleTabChange"
    />
    <FilterComponent
      ref="filterComponent"
      @change="handleFilterChange"
    />
    <TableComponent
      ref="tableComponent"
      @data-count="handleDataCount"
    />
  </b-card>
</template>

<script>
import TabComponent from '../../creator-management/Tab.vue'
import FilterComponent from './Filter.vue'
import TableComponent from './Table.vue'
import {
  CAMPAIGN_LIST_STATUS,
} from '../config'

export default {
  components: {
    TabComponent,
    FilterComponent,
    TableComponent,
  },
  data() {
    return {
      currentTab: this.$route.query.tab,
      currentFilter: {
        keyword: this.$route.query.keyword || '',
        sortBy: {
          key: this.$route.query.sort_key,
          type: this.$route.query.sort_type,
        },
      },
      campaignCounts: {
        'pre campaign': 0,
        ongoing: 0,
        draft: 0,
        ended: 0,
        cancel: 0,
      },
    }
  },
  computed: {
    tabList() {
      return ['Semua', ...Object.values(CAMPAIGN_LIST_STATUS).map(({ label }) => label)]
    },
  },
  mounted() {
    this.$nextTick(() => this.refreshData())
  },
  methods: {
    refreshData(data) {
      if (!this.$refs.tableComponent) return
      const status = this.currentTab === 'semua' ? undefined : this.currentTab?.replace(' ', '_').toLowerCase()
      const { keyword, sortBy } = this.currentFilter
      this.$refs.tableComponent.refreshData({
        status,
        search: keyword,
        sort_by: sortBy.key,
        sort_type: sortBy.type,
        ...data,
      })
    },
    handleTabChange(tab) {
      this.currentTab = tab
      if (this.$refs.filterComponent) this.$refs.filterComponent.resetAll()
    },
    handleFilterChange(filter) {
      this.currentFilter = filter
      this.refreshData()
    },
    handleDataCount(data) {
      this.campaignCounts = data
    },
  },
}
</script>
